import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Navigation from './Navigation';

const SignUpContent = ({ activeType, renderForm, setActiveType, types }) => (
  <>
    <Navigation activeType={activeType} onChange={setActiveType} types={types} />
    {renderForm}
  </>
);

SignUpContent.propTypes = {
  activeType: PropTypes.object,
  renderForm: PropTypes.node,
  setActiveType: PropTypes.func,
  types: PropTypes.arrayOf(PropTypes.object),
};

export default memo(SignUpContent);
